import { useState } from 'react';
import { TipoAtividade } from '@nexital/shared';
import { Dialogo } from '../design-system/Dialogo';
import { useLicitacao } from './contexto';

/** Lista vazia fixa: o seletor do store não pode devolver uma lista nova a cada leitura (laço infinito no React). */
const NENHUM: never[] = [];

/** Novo passo (com responsável) ou novo marco do cronograma, com prazo na hora local. */
export function DialogoAtividade({ tipo, fechar }: { tipo: TipoAtividade; fechar: () => void }) {
  const membros = useLicitacao((s) => s.dados?.membrosQuadro ?? NENHUM);
  const criar = useLicitacao((s) => s.criarAtividade);
  const [titulo, definirTitulo] = useState('');
  const [responsavelUuid, definirResponsavel] = useState('');
  const [prazo, definirPrazo] = useState('');
  const marco = tipo === TipoAtividade.Marco;
  const valido = titulo.trim() !== '' && (!marco || prazo !== '');

  const salvar = async () => {
    const gravou = await criar({
      tipo,
      titulo: titulo.trim(),
      responsavelUuid: responsavelUuid || null,
      prazo: prazo ? new Date(prazo).toISOString() : null,
    });
    if (gravou) fechar();
  };

  return (
    <Dialogo
      titulo={marco ? 'Novo marco do cronograma' : 'Novo passo'}
      rotuloConfirmar="Adicionar"
      podeConfirmar={valido}
      aoConfirmar={() => void salvar()}
      aoCancelar={fechar}
    >
      <label className="campo">
        {marco ? 'Marco (ex.: Sessão pública)' : 'O que precisa ser feito'}
        <input value={titulo} onChange={(e) => definirTitulo(e.target.value)} maxLength={200} />
      </label>
      {!marco && (
        <label className="campo">
          Responsável
          <select value={responsavelUuid} onChange={(e) => definirResponsavel(e.target.value)}>
            <option value="">Sem responsável</option>
            {membros.map((m) => (
              <option key={m.uuid} value={m.uuid}>{m.nome}</option>
            ))}
          </select>
        </label>
      )}
      <label className="campo">
        {marco ? 'Data e hora' : 'Prazo (opcional)'}
        <input type="datetime-local" value={prazo} onChange={(e) => definirPrazo(e.target.value)} />
      </label>
    </Dialogo>
  );
}
